export default "__VITE_ASSET__Dojv1BAC__"